import React from 'react';
import { Outlet } from 'react-router-dom';
import { PartnerAuthHeader } from '../components/PartnerAuthHeader';

export const PartnerSignupLayout = () => {
  return (
    <div className="partner-signup-flow" style={{ '--partner-auth-skyline': `url(${process.env.PUBLIC_URL}/images/image.png)` }}>
      <PartnerAuthHeader />
      <Outlet />
    </div>
  );
};
